export const FLAT_FORM_TYPE = {
    BEAUTYX: "BEAUTYX",
    MOMO: "MOMO",
    TIKI: "TIKI",
    MB: "MBBANK",
    ZALO: "ZALO",
    BEAUTYX_MOBILE:"BEAUTYX MOBILE",
    VIETTEL:"VIETTEL"
}